import type { ComponentProps } from 'react'

import {
  ICON_DEFAULT_COLOR,
  ICON_DEFAULT_FILL,
  ICON_DEFAULT_HEIGHT,
  ICON_DEFAULT_VIEWBOX,
  ICON_DEFAULT_WIDTH,
  type IconProps,
} from 'components'

export const FileInput = ({
  color = ICON_DEFAULT_COLOR,
  fill = ICON_DEFAULT_FILL,
  width = ICON_DEFAULT_WIDTH,
  height = ICON_DEFAULT_HEIGHT,
  viewBox = ICON_DEFAULT_VIEWBOX,
  ...props
}: ComponentProps<'svg'> & Omit<IconProps, 'icon'>) => {
  return (
    <svg
      fill={fill}
      height={height}
      viewBox={viewBox}
      width={width}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M 17.644531 23.894531 C 18.21875 23.324219 19.121094 23.285156 19.738281 23.789062 L 19.855469 23.894531 L 26.105469 30.144531 C 26.714844 30.753906 26.714844 31.746094 26.105469 32.355469 L 19.855469 38.605469 C 19.246094 39.214844 18.253906 39.214844 17.644531 38.605469 C 17.035156 37.996094 17.035156 37.003906 17.644531 36.394531 L 21.226562 32.8125 L 4.167969 32.8125 C 3.304688 32.8125 2.605469 32.113281 2.605469 31.25 C 2.605469 30.386719 3.304688 29.6875 4.167969 29.6875 L 21.226562 29.6875 L 17.644531 26.105469 L 17.539062 25.988281 C 17.035156 25.375 17.074219 24.46875 17.644531 23.894531 Z M 6.769531 16.667969 L 6.769531 8.332031 C 6.769531 6.8125 7.375 5.355469 8.449219 4.28125 C 9.523438 3.207031 10.980469 2.605469 12.5 2.605469 L 31.25 2.605469 C 31.664062 2.605469 32.0625 2.769531 32.355469 3.0625 L 42.769531 13.480469 C 43.0625 13.773438 43.230469 14.167969 43.230469 14.582031 L 43.230469 41.667969 C 43.230469 43.1875 42.625 44.644531 41.550781 45.71875 C 40.476562 46.792969 39.019531 47.394531 37.5 47.394531 L 8.332031 47.394531 C 7.46875 47.394531 6.769531 46.695312 6.769531 45.832031 C 6.769531 44.96875 7.46875 44.269531 8.332031 44.269531 L 37.5 44.269531 C 38.191406 44.269531 38.851562 43.996094 39.339844 43.507812 C 39.828125 43.019531 40.105469 42.355469 40.105469 41.667969 L 40.105469 18.230469 L 33.332031 18.230469 C 31.8125 18.230469 30.355469 17.625 29.28125 16.550781 C 28.207031 15.476562 27.605469 14.019531 27.605469 12.5 L 27.605469 5.730469 L 12.5 5.730469 C 11.808594 5.730469 11.148438 6.003906 10.660156 6.492188 C 10.171875 6.980469 9.894531 7.644531 9.894531 8.332031 L 9.894531 16.667969 C 9.894531 17.53125 9.195312 18.230469 8.332031 18.230469 C 7.46875 18.230469 6.769531 17.53125 6.769531 16.667969 Z M 30.730469 12.5 C 30.730469 13.191406 31.003906 13.851562 31.492188 14.339844 C 31.980469 14.828125 32.644531 15.105469 33.332031 15.105469 L 39.976562 15.105469 L 30.730469 5.855469 Z M 30.730469 12.5 "
        fill={color}
      />
    </svg>
  )
}
